import { QueryClient } from '@tanstack/react-query'
import { isTerminalApiError } from '@omnea-app/packages/universal/error-handling/isApiErrorOfType'
import { QUERY_TIME_CONFIG } from './queryConfig'

const TWENTY_MINUTES = 1000 * 60 * 20

export function createQueryClient(): QueryClient {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          // Don't retry client errors that won't resolve on retry
          if (isTerminalApiError(error)) return false

          // Retry up to 3 times otherwise (React Query default)
          return failureCount < 3
        },
        refetchOnWindowFocus: false, // default: true
        gcTime: QUERY_TIME_CONFIG.DEFAULT_GC_TIME,
        staleTime: QUERY_TIME_CONFIG.DEFAULT_STALE_TIME,
      },
    },
  })

  queryClient.setQueryDefaults(['coreDataItem'], {
    staleTime: TWENTY_MINUTES,
  })

  // These entries are seeded observer-less (via setQueryData) and read unguarded at render time,
  // so eviction mid-session silently flips conditionality and drops answered questions.
  // The prefix must match `customCoreDataPrefillPathNodesKey` in useCustomCoreDataPrefillPath.ts;
  // it's duplicated here rather than imported to avoid a shared -> feature package dependency.
  queryClient.setQueryDefaults(['customCoreDataPrefillPathNodes'], {
    gcTime: Infinity,
  })

  return queryClient
}
